<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col">
          <!-- Submenu -->
          <div
            v-if="apidata.me.properties.tac_role === 'manager'"
            class="sub-menu"
          >
            <router-link
              to="/reps"
              custom
              v-slot="{ href, route, navigate, isActive, isExactActive }"
            >
              <div :class="{ active: isExactActive }" @click="navigate">
                All reps
              </div>
            </router-link>
            <div class="active" v-if="$route.name === 'View rep'">
              View rep
            </div>
          </div>
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
